<template>
  <div class="homePage" id="home">
      <div style="padding-top: 80px;">
          <HelloWorld></HelloWorld>
      </div>
      <!--公司介绍-->
      <div id="about">
          <div class="product">
              <div class="titleBox">
                  <div class="title">{{$t('lang.homePage.AboutUs')}}</div>
              </div>
              <div class="optionBox">
                  <div :class="active=='1'?'option active':'option'" @click="choose('1')">{{$t('lang.homePage.gsfzlc')}}</div>
                  <div :class="active=='2'?'option active':'option'" @click="choose('2')">{{$t('lang.homePage.tdsl')}}</div>
                  <div :class="active=='3'?'option active':'option'" @click="choose('3')">{{$t('lang.homePage.gsyj')}}</div>
              </div>
          </div>
          <div v-if="active =='1'" class="">
              <div class="visible-md-block visible-lg-block messageBox">
                  <div class="fazhanlichengBox">
                      <ul class="cl" style="color: #fff;text-align: center">
                          <li class="fl" style="width: 20%" @mouseover="mouseEnter('2016')">
                              <div class="flgBox" style="height: 350px" v-if="flagTag == '2016'">
                                  <div class="flag flag1 cl">
                                        <div class="fr message">
                                            <div class="t">2016年8月</div>
                                            <div class="d">{{$t('lang.homePage.m2016')}}</div>
                                        </div>
                                  </div>
                              </div>
                              <div style="width: 100%;position: absolute;top: 350px;">
                                  <div><img src="../../assets/images/3.png" alt=""></div>
                                  <div class="yearBox">2016</div>
                              </div>
                          </li>
                          <li class="fl" style="width: 20%" @mouseover="mouseEnter('2017')">
                              <div class="flgBox" style="height: 350px" v-if="flagTag == '2017'">
                                  <div class="flag flag2">
                                      <div class="fr message">
                                          <div class="t">2017年4月</div>
                                          <div class="d">{{$t('lang.homePage.m2017')}}</div>
                                      </div>
                                  </div>
                              </div>
                              <div style="width: 100%;position: absolute;top: 350px;">
                                  <div><img src="../../assets/images/3.png" alt=""></div>
                                  <div class="yearBox">2017</div>
                              </div>
                          </li>
                          <li class="fl" style="width: 20%" @mouseover="mouseEnter('2018')">
                              <div class="flgBox" style="height: 350px" v-if="flagTag == '2018'">
                                  <div class="flag flag3">
                                      <div class="fr message">
                                          <div class="t">2018年</div>
                                          <div class="d">{{$t('lang.homePage.m2018')}}</div>
                                      </div>
                                  </div>
                              </div>
                              <div style="width: 100%;position: absolute;top: 350px;">
                                  <div><img src="../../assets/images/3.png" alt=""></div>
                                  <div class="yearBox">2018</div>
                              </div>
                          </li>
                          <li class="fl" style="width: 20%" @mouseover="mouseEnter('2019')">
                              <div class="flgBox" style="height: 350px" v-if="flagTag == '2019'">
                                  <div class="flag flag4">
                                      <div class="fr message">
                                          <div class="t">2019年</div>
                                          <div class="d">{{$t('lang.homePage.m2019')}}</div>
                                      </div>
                                  </div>
                              </div>
                              <div style="width: 100%;position: absolute;top: 350px;">
                                  <div><img src="../../assets/images/3.png" alt=""></div>
                                  <div class="yearBox">2019</div>
                              </div>
                          </li>
                          <li class="fl" style="width: 20%" @mouseover="mouseEnter('2020')">
                              <div class="flgBox" style="height: 350px" v-if="flagTag == '2020'">
                                  <div class="flag flag5">
                                      <div class="fr message">
                                          <div class="t">2020年</div>
                                          <div class="d">{{$t('lang.homePage.m2020')}}</div>
                                      </div>
                                  </div>
                              </div>
                              <div style="width: 100%;position: absolute;top: 350px;">
                                  <div><img src="../../assets/images/3.png" alt=""></div>
                                  <div class="yearBox">2020</div>
                              </div>
                          </li>
                      </ul>
                      <!--光效-->
                      <!--<div class="highLight">-->
                          <!--&lt;!&ndash;<img src="../../assets/images/guang.png" alt="">&ndash;&gt;-->
                          <!--<img src="../../assets/images/guangnew.gif" alt="">-->
                      <!--</div>-->
                  </div>
              </div>
              <div class="visible-sm-block visible-xs-block mmessageBox">
                  <div class="mfazhanlichengBox">
                      <ul class="cl">
                          <li class="cl" style="position: relative">
                              <div class="col-xs-4" style="text-align: center">
                                  <img src="../../assets/images/3.png" alt="">
                              </div>
                              <div class="col-xs-8">
                                  <div class="t">2016年8月</div>
                                  <div class="d">{{$t('lang.homePage.m2016')}}</div>
                              </div>
                          </li>
                          <li class="cl" style="position: relative">
                              <div class="col-xs-4" style="text-align: center">
                                  <img src="../../assets/images/3.png" alt="">
                              </div>
                              <div class="col-xs-8">
                                  <div class="t">2017年4月</div>
                                  <div class="d">{{$t('lang.homePage.m2017')}}</div>
                              </div>
                          </li>
                          <li class="cl" style="position: relative">
                              <div class="col-xs-4" style="text-align: center">
                                  <img src="../../assets/images/3.png" alt="">
                              </div>
                              <div class="col-xs-8">
                                  <div class="t">2018年</div>
                                  <div class="d">{{$t('lang.homePage.m2018')}}</div>
                              </div>
                          </li>
                          <li class="cl" style="position: relative">
                              <div class="col-xs-4" style="text-align: center">
                                  <img src="../../assets/images/3.png" alt="">
                              </div>
                              <div class="col-xs-8">
                                  <div class="t">2019年</div>
                                  <div class="d">{{$t('lang.homePage.m2019')}}</div>
                              </div>
                          </li>
                          <li class="cl" style="position: relative">
                              <div class="col-xs-4" style="text-align: center">
                                  <img src="../../assets/images/3.png" alt="">
                              </div>
                              <div class="col-xs-8">
                                  <div class="t">2020年</div>
                                  <div class="d">{{$t('lang.homePage.m2020')}}</div>
                              </div>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
          <!--团队实力-->
          <div v-if="active =='2'" class="teamStrength">
              <div class="cl" style="width: 80%;margin: 0 auto">
                  <div class="pull-right col-md-7 col-xs-12">
                      <p class="detail">{{$t('lang.homePage.teamAtrength1')}}</p>
                      <p class="detail">{{$t('lang.homePage.teamAtrength2')}}</p>
                      <p class="detail">{{$t('lang.homePage.teamAtrength3')}}</p>
                  </div>
                  <div class="pull-right col-md-5 col-xs-12" >
                      <div style="width: 95%;margin: 0 auto;">
                          <img src="../../assets/images/person.png" alt="" width="100%" style="">
                      </div>
                  </div>
              </div>
          </div>
          <!--公司愿景-->
          <div v-if="active =='3'" class="companyYj">
              <div style="width: 80%;margin: 0 auto">
                  <div class="row">
                      <div class="col-sm-4 col-xs-12">
                          <div class="yj">
                              <div>
                                  <img src="../../assets/images/hxjzg.png" alt="" height="224px">
                              </div>
                              <div class="title">{{ $t('lang.homePage.senseOfWorth') }}</div>
                              <div class="con">{{ $t('lang.homePage.detail1') }}</div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-xs-12">
                          <div class="yj">
                              <div>
                                  <img src="../../assets/images/gssm.png" alt="" height="224px">
                              </div>
                              <div class="title">{{ $t('lang.homePage.corporateMission') }}</div>
                              <div class="con">{{ $t('lang.homePage.detail2') }}</div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-xs-12">
                          <div class="yj">
                              <div>
                                  <img src="../../assets/images/zlmb.png" alt="" height="224px">
                              </div>
                              <div class="title">{{ $t('lang.homePage.strategic') }}</div>
                              <div class="con">{{ $t('lang.homePage.detail3') }}</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

      </div>
      <!--<div class="mobile visible-xs-block visible-sm-block">-->
      <!--</div>-->
      <!--产品和服务-->
      <!--<div class="product visible-md-block visible-lg-block">-->
      <div id="product" class="product">
          <div class="titleBox">
              <div class="title" :style="lang == 'en-US'?'':'width:340px'">{{$t('lang.header.service')}}</div>
          </div>
          <div class="row">
              <div @click="toMore('/game')" class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="cursor: pointer">
                  <div class="producs">
                      <div class="image">
                          <img src="../../assets/images/product2.png" alt="" width="100%">
                      </div>
                      <div class="productName">{{$t('lang.homePage.faxingyw')}}</div>
                      <div class="more">{{$t('lang.homePage.readMore')}} <img src="../../../static/img/jt.png" alt="" style="width: 7px;margin-top: -4px;margin-left: 8px;"></div>
                  </div>
              </div>
              <div @click="toMore('/business')" class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="cursor: pointer">
                  <div class="producs">
                      <div class="image">
                          <img src="../../assets/images/product1.png" alt="" width="100%">
                      </div>
                      <div class="productName">{{$t('lang.homePage.bendihYw')}}</div>
                      <div class="more">{{$t('lang.homePage.readMore')}} <img src="../../../static/img/jt.png" alt="" style="width: 7px;margin-top: -4px;margin-left: 8px;"></div>
                  </div>
              </div>
          </div>
      </div>
      <!--<div class="productMobile visible-xs-block visible-sm-block">-->
      <!--</div>-->
      <!--联系我们-->
      <div id="contactUs" class="product">
          <div class="titleBox">
              <div class="title">{{$t('lang.header.concatUs')}}</div>
          </div>
          <div class="row">
              <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="module">
                      <div class="image">
                          <img src="../../assets/images/img1.jpg" alt="" width="100%">
                      </div>
                      <div class="moduleName" style="border-color: #b93a80"><a href="">{{$t('lang.homePage.cpyr')}}</a></div>
                      <div class="add">christina.liu@arabonline.cn</div>
                  </div>
              </div>
              <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="module">
                      <div class="image">
                          <img src="../../assets/images/img2.jpg" alt="" width="100%">
                      </div>
                      <div class="moduleName" style="border-color: #0e7672"><a href="">{{$t('lang.homePage.swpphz')}}</a></div>
                      <div class="add">christina.liu@arabonline.cn</div>
                  </div>
              </div>
              <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="module">
                      <div class="image">
                          <img src="../../assets/images/img3.jpg" alt="" width="100%">
                      </div>
                      <div class="moduleName" style="border-color: #51c85c"><a href="">{{$t('lang.homePage.qdhz')}}</a></div>
                      <div class="add">christina.liu@arabonline.cn</div>
                  </div>
              </div>
              <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="module">
                      <div class="image">
                          <img src="../../assets/images/img4.jpg" alt="" width="100%">
                      </div>
                      <div class="moduleName" style="border-color: #ffa746"><a href="">{{$t('lang.homePage.jrqm')}}</a></div>
                      <div class="add">christina.liu@arabonline.cn</div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  },
    data() {
        return {
            active: 1,
            lang:this.$i18n.locale,
            flagTag:'2018'
        }
    },
    mounted(){
        this.$i18n.locale = localStorage.lang?localStorage.lang:'zh-CN'
    },
    methods: {
        choose(index) {
            this.active = index;
        },
        toMore(path){
            this.$router.push(path)
        },
        mouseEnter(num){
            this.flagTag = num
        }
    },
}
</script>
<style>
    .homePage .product{
        width: 80%;
        margin: 0 auto;
        padding: 80px 0 0;
        background: #fff;
    }
    .homePage .product .titleBox{
       height: 2px;
        background: #d1d1d1;
        position: relative;
        margin-bottom: 100px;
    }
    .homePage .product .titleBox .title{
        width: 309px;
        background: #fff;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        top: -25px;
        text-align: center;
        font-size: 32px;
        font-weight: bold;
        letter-spacing: 4px;
        color: #020202;
    }
    .homePage .product .producs{
        width: 90%;
        margin: 0 auto 60px;
    }
    /*@media (max-width: 992px){*/

        /*.homePage .product .producs{*/
            /*width: 90%;*/
            /*margin: 0 auto 80px;*/
        /*}*/
    /*}*/
    .homePage .product .producs .image{
        width:100%;
        /*height: 300px;*/
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        background: #bdbcb5;
        margin-bottom: 40px;
        overflow: hidden;
    }
    .homePage .product .producs .productName{
        font-size: 24px;
        line-height: 24px;
        margin-bottom: 15px;
        color: #080808;
    }
    .homePage .product .producs .more{
        font-size: 14px;
        line-height: 20px;
        /*margin-bottom: 15px;*/
        color: #080808;
        cursor: pointer;
    }
    .homePage .product .module{
        width: 95%;
        margin: 0 auto 100px;
    }
    .homePage .product .module .image{
        width: 100%;
        /*height: 150px;*/
        border-radius: 3px;
        background: #bdbcb5;
        margin-bottom: 20px;
        overflow: hidden;
    }
    .homePage .product .module .moduleName{
        display: inline-block;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 5px solid #000;
    }
    .homePage .product .module .moduleName a{
        color: #5c5c5c;
        font-weight: bold;
    }
    .homePage .product .module .add{
        font-size: 14px;
        line-height: 20px;
        color: #848c94;
    }
    .homePage .product .optionBox{
        text-align: center;
        margin-top: -55px;
        margin-bottom: 25px;
    }
    .homePage .product .optionBox .option{
        display: inline-block;
        margin: 0 15px;
        font-size: 18px;
        line-height: 20px;
        padding-bottom: 10px;
        color: #777;
        cursor: pointer;
        font-weight: bold;
    }
    .homePage .product .optionBox .option.active{
        color: #0b0b0b;
        border-bottom: 5px solid #000;
    }
    .homePage .messageBox{
        background: #000000;
        height: 500px;
        background-image: url("../../assets/images/timeBacImg.png");
        background-repeat: no-repeat;
        background-size: auto 100%;
        background-position: center;
    }
    .homePage .mmessageBox{
        background: #fff;
        height: 500px;
    }
    .homePage .mmessageBox .mfazhanlichengBox{
        width: 80%;
        margin: 0 auto;
    }
    .homePage .mmessageBox .mfazhanlichengBox li{
        margin: 30px 0;
    }
    .homePage .mmessageBox .mfazhanlichengBox .t{
        font-size: 18px;
        font-weight: bold;
    }
    .homePage .mmessageBox .mfazhanlichengBox .d{
        font-size: 14px;
    }
    .homePage .messageBox .yearBox{
        font-size: 20px;
        font-weight: bold;
        margin-top: 20px;
    }
    .homePage .messageBox .fazhanlichengBox{
        width: 80%;margin: 0 auto;
        background-image: url("../../assets/images/timeX.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: 0% 80%;
        position: relative;
    }
    @keyframes myfirst
    {
        from {transform: translateX(0%);}
        to {transform: translateX(900%);}
    }
    .homePage .messageBox .fazhanlichengBox .highLight{
        position: absolute;bottom: 68px;
        /*animation: myfirst 2s ease-out;*/
        /*-moz-animation: myfirst 2s ease-out;	!* Firefox *!*/
        /*-webkit-animation: myfirst 2s ease-out;	!* Safari 和 Chrome *!*/
        /*-o-animation: myfirst 2s ease-out;*/
        /*animation-iteration-count: infinite;*/
        /*!* Firefox: *!*/
        /*-moz-animation-iteration-count: infinite;*/
        /*!* Safari 和 Chrome: *!*/
        /*-webkit-animation-iteration-count: infinite;*/
        /*!* Opera: *!*/
        /*-o-animation-iteration-count: infinite;*/
    }
    .homePage .messageBox .fazhanlichengBox ul li{
        position: relative;
        height: 500px;
        cursor: pointer;
    }
    .homePage .messageBox .fazhanlichengBox ul li .flgBox{
        background-image: url("../../assets/images/timeY.png");
        background-repeat: no-repeat;
        background-position: center bottom;
        position: relative;
    }
    .homePage .messageBox .fazhanlichengBox ul li .flgBox .flag{
        width: 423px;
        height: 154px;
        background-size:auto 100%;
        background-repeat: no-repeat;
        background-position: center;
        position: absolute;
        left: 50%;
        top: 70px;
        margin-left: -211px;
    }
    .homePage .messageBox .fazhanlichengBox ul li .flgBox .flag.flag1{
        background-image: url("../../assets/images/2016.png");
    }
    .homePage .messageBox .fazhanlichengBox ul li .flgBox .flag.flag2{
        background-image: url("../../assets/images/2017.png");
    }
    .homePage .messageBox .fazhanlichengBox ul li .flgBox .flag.flag3{
        background-image: url("../../assets/images/2018.png");
    }
    .homePage .messageBox .fazhanlichengBox ul li .flgBox .flag.flag4{
        background-image: url("../../assets/images/2019.png");
    }
    .homePage .messageBox .fazhanlichengBox ul li .flgBox .flag.flag5{
        background-image: url("../../assets/images/2020.png");
    }
    .homePage .messageBox .fazhanlichengBox ul li .flgBox .flag .message{
        width: 50%;height: 100%;color: #000;text-align: left;
        padding: 15px 25px;
    }
    .homePage .messageBox .fazhanlichengBox ul li .flgBox .flag .message .t{
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .homePage .messageBox .fazhanlichengBox ul li .flgBox .flag .message .d{
        font-size: 12px;
        /*word-break: keep-all;*/
    }
    .companyYj .yj{
        width: 90%;
        margin: 100px auto;
        text-align: center;
    }
    .companyYj .yj .title{
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 22px;
        margin-top: 30px;
    }
    .companyYj .yj .con{
        text-align: center;
        font-size: 14px;
    }
    .teamStrength{
        margin: 100px 0;
    }
    .teamStrength p.detail{
        margin: 70px 0;
    }
    @media (max-width: 992px){
        .teamStrength{
            margin: 0;
        }

        .homePage .mmessageBox{
            background: #fff;
            height: auto;
        }
    }
    @media (max-width: 768px){
        .companyYj .yj{
            margin: 40px auto;
        }
        .homePage .product{
            width: 90%;
        }
        .homePage .product .optionBox .option{
            font-size: 12px;
        }
        .homePage .product .optionBox .option.active{
            border-bottom: 2px solid #000;
        }
        .teamStrength p.detail{
            margin: 35px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue